<template>
  <div id="app">
    <img class="toplogo" alt="Design of Scandinavia" src="./assets/dos_logo.png">
    <div class="greyfield">&nbsp;</div>
    <div class="toptext">Design of Scandinavia Gåvokort har upphört!<br>Har Du oinlösa gåvokort så hjälper vi dig.<br />Kontakta oss på mail eller telefon. Se info nedan.</div>
    <div class="topimage"><img src="./assets/topimage.jpg"></div>
    <doslist msg="Här hittar du alla produkter som finns att välja på"/>
            <div class="footer">
          <div class="mail">
            <strong>Kontakta oss</strong><br />
            Mail info@actera.se<br />Telefon 0411-498 50
          </div>
        </div>
  </div>
</template>

<script>
import doslist from './components/doslist.vue'


export default {
  name: 'App',
  components: {
    doslist
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

</style>
